// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.frame-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 72px;
}
.frame-container .frame-svg {
  width: 100%;
  max-width: 900px;
  height: auto;
}
.frame-container .base-line {
  stroke: #000;
  stroke-width: 2;
}
.frame-container .column {
  stroke: #333;
  stroke-width: 3;
}
.frame-container .roof {
  stroke: #111;
  stroke-width: 2.5;
}
.frame-container .label {
  font-size: 14px;
  font-family: Arial, sans-serif;
  fill: #000;
}
.frame-container .ridge {
  font-weight: bold;
  fill: #444;
}
.frame-container .arrow {
  stroke: #000;
  stroke-width: 1.5;
}
.frame-container .arrow-head {
  fill: #000;
}
.frame-container .caption {
  margin-top: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/smart_construction_app/Customer_V4/Estimate/FrameCrossSection.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,iBAAA;AAAF;AAIE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAFJ;AAKE;EACE,YAAA;EACA,eAAA;AAHJ;AAME;EACE,YAAA;EACA,eAAA;AAJJ;AAOE;EACE,YAAA;EACA,iBAAA;AALJ;AAQE;EACE,eAAA;EACA,8BAAA;EACA,UAAA;AANJ;AASE;EACE,iBAAA;EACA,UAAA;AAPJ;AAUE;EACE,YAAA;EACA,iBAAA;AARJ;AAWE;EACE,UAAA;AATJ;AAYE;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAVJ","sourcesContent":[".frame-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  // margin: 2rem;\n  padding-top: 72px;\n\n  \n\n  .frame-svg {\n    width: 100%;\n    max-width: 900px;\n    height: auto;\n  }\n\n  .base-line {\n    stroke: #000;\n    stroke-width: 2;\n  }\n\n  .column {\n    stroke: #333;\n    stroke-width: 3;\n  }\n\n  .roof {\n    stroke: #111;\n    stroke-width: 2.5;\n  }\n\n  .label {\n    font-size: 14px;\n    font-family: Arial, sans-serif;\n    fill: #000;\n  }\n\n  .ridge {\n    font-weight: bold;\n    fill: #444;\n  }\n\n  .arrow {\n    stroke: #000;\n    stroke-width: 1.5;\n  }\n\n  .arrow-head {\n    fill: #000;\n  }\n\n  .caption {\n    margin-top: 1rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
